import * as React from 'react';
import { Head } from 'react-static';
import { SITE_TITLE } from '../../common/constants';
import { decodeHtmlEntities } from '../../common/helpers/htmlEntities';
import { MARKET } from '../../config/browser';
import { HeadTitleProps } from './HeadTitle.props';

export const HeadTitle = ({ title }: HeadTitleProps) => {
  const siteTitleDecoded = decodeHtmlEntities(SITE_TITLE);
  let fullTitle: string = siteTitleDecoded;

  if (title) {
    const cleanTitle = decodeHtmlEntities(title);
    fullTitle = MARKET === 'UK' ? cleanTitle : `${siteTitleDecoded} | ${cleanTitle}`;
  }

  return (
    <Head>
      <title>{fullTitle}</title>
      <meta property='og:title' content={fullTitle} />
    </Head>
  );
};
